import React, { type ReactElement } from 'react';
import type { EdgePreviewT, PendingNodeT, TemplateNodeT } from '../../../../labelling-v2/types/skeleton-template-builder.type';
import { CSS_VARIABLE_STAGE_VISIBLE_SCALE } from '../../../constants/stage-css-variables';
import { CANVAS } from '../../../constants/template-builder';
type CanvasPreviewLayerPropsT = {
  edgePreview: EdgePreviewT | null;
  pendingNode: PendingNodeT | null;
  nodeMap: Map<string, TemplateNodeT>;
  color: string;
};
export function CanvasPreviewLayer({
  edgePreview,
  pendingNode,
  nodeMap,
  color
}: CanvasPreviewLayerPropsT) {
  if (!edgePreview && !pendingNode) return null;
  let edgePreviewLine: ReactElement | null = null;
  if (edgePreview) {
    const sourceNode = nodeMap.get(edgePreview.sourceNodeId);
    if (sourceNode) {
      edgePreviewLine = <line x1={sourceNode.x} y1={sourceNode.y} x2={edgePreview.xPx} y2={edgePreview.yPx} stroke={color} style={{
        strokeWidth: `calc(${CANVAS.EDGE_STROKE_WIDTH}px * var(${CSS_VARIABLE_STAGE_VISIBLE_SCALE}))`
      }} opacity={CANVAS.EDGE_PREVIEW_OPACITY} />;
    }
  }
  let pendingNodeCircle: ReactElement | null = null;
  if (pendingNode) {
    const {
      x: cx,
      y: cy
    } = pendingNode;
    pendingNodeCircle = <circle cx={cx} cy={cy} r={CANVAS.NODE_RADIUS} fill={color} style={{
      transformOrigin: `${cx}px ${cy}px`,
      transform: `scale(var(${CSS_VARIABLE_STAGE_VISIBLE_SCALE}))`
    }} />;
  }
  return <g style={{
    pointerEvents: 'none'
  }}>
      {edgePreviewLine}
      {pendingNodeCircle}
    </g>;
}